
/* injects from baggage-loader */

'use strict';

import PageNotFoundComponent from './page-not-found.component';

const PageNotFoundPageModule = angular.module('page-not-found-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('page-not-found', {
        url: '/page-not-found',
        component: 'pageNotFound',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('pageNotFound', new PageNotFoundComponent());

export default PageNotFoundPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/page-not-found/page-not-found.module.js